import { apiFetch } from './client'
import type { Quote } from '../types'

export interface AdminQuote {
  uuid: string
  quote_number: string
  status: 'draft' | 'sent' | 'accepted' | 'expired' | 'converted'
  customer_name: string
  customer_email: string
  customer_company: string | null
  total: string
  currency: string
  created_at: string
  updated_at: string
}

export interface AdminQuoteDetail extends AdminQuote {
  items: Array<{ mpn: string; title: string; unit_price: string; quantity: number; subtotal: string }> | null
}

export async function fetchAdminQuotes(): Promise<AdminQuote[]> {
  const res = await apiFetch<{ data: AdminQuote[] }>('/quotes')
  return res.data
}

export async function fetchAdminQuote(uuid: string): Promise<AdminQuoteDetail> {
  const res = await apiFetch<{ data: AdminQuoteDetail }>(`/quotes/${uuid}`)
  return res.data
}

export async function fetchQuote(id: string): Promise<Quote> {
  return apiFetch<Quote>(`/quotes/${id}`)
}

export interface CreateQuoteRequest {
  customerName: string
  customerEmail: string
  customerCompany: string
  customerPhone?: string
  customerReference?: string
  notes?: string
  items: Array<{ mpn: string; title: string; unitPrice: string; quantity: number }>
}

export interface CreateQuoteResponse {
  uuid: string
  quote_number: string
}

export async function createQuoteFromCart(data: CreateQuoteRequest): Promise<CreateQuoteResponse> {
  const res = await apiFetch<{ data: CreateQuoteResponse }>('/quotes', {
    method: 'POST',
    body: JSON.stringify(data),
  })
  return res.data
}

export interface AccountQuote {
  uuid: string
  quote_number: string
  status: 'draft' | 'sent' | 'accepted' | 'expired' | 'converted'
  customer_name: string
  customer_email: string
  customer_company: string | null
  total: string
  currency: string
  valid_until: string | null
  items: Array<{ mpn: string; title: string; unit_price: string; quantity: number; subtotal: string }> | null
  created_at: string
  updated_at: string
}

export async function fetchAccountQuotes(): Promise<AccountQuote[]> {
  const res = await apiFetch<{ data: AccountQuote[] }>('/me/quotes')
  return res.data
}
